<template>
  <v-container fill-height fluid class="pa-0" id="home">

    <v-layout row wrap>
      <!--#######################   左半分   ##################################-->
      <v-flex xs12 sm3 class="white" id="home-notifications">
        <!-- 日付表示部 -->
        <div class="text-xs-center pt-2 pb-1 grey lighten-4">
          <h2 class="grey--text text--darken-3">{{now}}</h2>
          <p class="grey--text ma-0">{{user.organizationName}}</p>
        </div>
        <!-- 通知 -->
        <v-expansion-panel>
          <v-expansion-panel-content v-bind:value="true">
            <div slot="header">
              <h3>
                {{$t("home.notification")}} ({{notifications.length}})
              </h3>
            </div>
            <v-divider></v-divider>
            <div class="pt-1">
              <div v-for="notfctn in notifications">
                <router-link :to="{ path: 'watersystem_list/' + notfctn.id }">
                  <v-alert outline :color="notfctn.type" :icon="notfctn.type" :value="true" :class="notfctn.type=='error'?'red':'orange'" class="ma-2 pa-1 lighten-5">
                    <span class="body-2">{{notfctn.title}}</span><br>
                    <span class="body-2">[ {{notfctn.service}} ]</span><br>
                    <span class="caption">{{notfctn.message}}</span>
                  </v-alert>
                </router-link>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <!--#######################   右半分 mt-4 共通 ##################################-->
      <v-flex xs12 sm9 class="  grey lighten-5 pt-2 pr-4 pl-4" id="home-main">

        <!-- お知らせ -->
          <v-expansion-panel>
          <v-expansion-panel-content  v-bind:value="true">
            <div class="" slot="header">
              <h3>{{information}}</h3>
            </div>
            <v-layout>
              <v-flex>
                <v-card class="mt-1">
                  <div class="infomation-text" >{{this.mailDate}} - {{$t("home.mail-notification-top")}}</div>
                  <div class="infomation-text" v-html="$t('home.mail-notification-under',['./settings/notifications_mail'])"></div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- クイックリンク -->
        <v-expansion-panel class="mt-4">
          <v-expansion-panel-content  v-bind:value="true">
            <div class="" slot="header">
              <h3>{{$t("home.quick-link")}}</h3>
            </div>
            <v-layout row wrap >

              <v-flex sm6 md3>
                <v-card class="mt-2">
                  <v-layout align-center row @click="quickLink('customer')">
                    <v-flex xs2>
                      <v-avatar size="40px" class="ml-2" tile>
                        <img src="../assets/images/stats-pin.png" alt="" >
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10>
                      <v-card-title class="pb-1">
                        <span class="blue--text caption">{{$t("global-menu.watersystem")}}</span>
                      </v-card-title>
                      <v-card-text class="pt-0">
                        <span>{{$t("watersystem.customer")}} ({{locationCount}})</span>
                      </v-card-text>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>


              <v-flex sm6 md3>
                <v-card class="ma-2">
                  <v-layout align-center row @click="quickLink('device')">
                    <v-flex xs2>
                      <v-avatar size="40px" class="ml-2" tile>
                        <img src="../assets/images/stats-iotizr.png" alt="" >
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10>
                      <v-card-title class="pb-1">
                        <span class="blue--text caption">{{$t("global-menu.watersystem")}}</span>
                      </v-card-title>
                      <v-card-text class="pt-0">
                        <span>{{$t("watersystem.device")}} ({{filtrationSystemCount}})</span>
                      </v-card-text>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- カレンダー -->
        <v-expansion-panel class="mt-4">
          <v-expansion-panel-content class="grey lighten-2" :value="true">
            <div slot="header">
              <h3>{{$t("home.calendar")}}</h3>
            </div>
            <v-card class="white pa-2">
              <full-calendar :events="calendarEvents" :config="calendarConfig"></full-calendar>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import http from '@/utils/http.js'
import moment from 'moment'
import utils from '@/utils/utils.js'
import statuscheck from '@/utils/statuscheck.js'

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      user: this.$store.getters.user, // ログインユーザ
      // 時刻表示用
      timeZone: moment.tz.guess(),
      now: utils.dateFormatter(
        this.$store.getters.locale,
        Date.now(),
        {
          // Intl.DateTimeFormatの日本語表記バグ対応
          month: this.$store.getters.locale === 'ja-JP' || this.$store.getters.locale === 'ja' ? 'narrow' : 'long',
          day: 'numeric',
          weekday: 'short',
          timeZone: moment.tz.guess()
        }),

      needToReplace: [],
      notifications: [], // Notification用データ
      locationCount: 0,
      filtrationSystemCount: 0,
      toggle: {
        notification: true
      },
      calendarEvents: [],
      calendarConfig: {
        defaultView: 'month',
        eventRender: function (event, element) {},
        locale: this.$store.getters.locale,
        eventColor: '#FDD',
        eventTextColor: '#888',
        selectable: false,
        eventClick: function (event, element) {}
      },
      mailDate: '',
      language: 'en',
      information: ''
    }
  },
  methods: {
    init () {
      this.getNeedtoReplace()
      this.getNotificationDate()
      this.getDomainConfig()
      this.getFiltrationSystemCount()
      this.getLocationCount()
    },
    getNotificationDate () {
      this.mailDate = moment('2018-08-30').tz(this.timeZone).format('YYYY-MM-DD')
      const languageString = window.localStorage.getItem('language')
      if (languageString !== null) {
        this.language = JSON.parse(languageString).language
      } else {
        if (this.$store.getters.locale === 'ja' || this.$store.getters.locale === 'ja-JP') {
          this.language = 'ja'
        } else {
          this.language = 'en'
        }
      }
    },
    getNeedtoReplace () {
      http.request('post', '/service2/dashboard/api/organizations/filtrationSystemList', {needReplace: true})
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get needToReplace data failed. (' + data.result + ')')
            return
          }
          this.needToReplace = data.filtrationSystems

          // console.log(this.needToReplace)
          if (this.needToReplace.length > 0) {
            this.setNextReplacementDateToCalendar()
            this.generateNotifications()
          } else {
            // 交換必須なシステムがなくても値が残っているので空にする
            this.needToReplace = []
            this.notifications = []
          }
        })
        .catch(error => {
          // TODO エラー処理
          console.log('need to replece API error', error)
        })
    },
    setNextReplacementDateToCalendar () { // カレンダーに日付をセットする
      this.needToReplace.forEach(fs => {
        fs.services.forEach(service => {
          if (service.serviceId === 1) {
            const time = service.filters[0].nextReplacementTime
            const date = moment(time).tz(this.timeZone).format('YYYY-MM-DD')
            const event = {
              title: fs.filtrationSystemName,
              start: date,
              allDay: true
            }
            this.calendarEvents.push(event)
          }
        })
      })
    },
    generateNotifications () { // Notification用のデータを作る
      const self = this
      this.needToReplace.forEach(fs => {
        fs.services.forEach(service => {
          const statusByService = statuscheck.getPluginStatusValue(service)
          if (statusByService === 0) {
            return
          }
          const notificationSettings = statuscheck.getNotificationSettings(statusByService)
          const type = notificationSettings.type
          const message = self.$i18n.t(notificationSettings.messageKey)

          if (service.serviceId === 1) {
            if (type !== '') {
              this.notifications.push({
                type: type, // error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: self.$i18n.t('service.flow-and-time'),
                id: fs.filtrationSystemId
              })
            }
          }
          if (service.serviceId === 2) {
            if (type !== '') {
              this.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: self.$i18n.t('service.ro-membrane'),
                id: fs.filtrationSystemId
              })
            }
          }
          if (service.serviceId === 3) {
            if (type !== '') {
              this.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: 'A' + service.portNumber + ' ' + self.$i18n.t('service.temperature'),
                id: fs.filtrationSystemId
              })
            }
          }
          if (service.serviceId === 4) {
            if (type !== '') {
              this.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: 'A' + service.portNumber + ' ' + self.$i18n.t('service.leakage'),
                id: fs.filtrationSystemId
              })
            }
          }
          if (service.serviceId === 5) {
            if (type !== '') {
              this.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: 'A' + service.portNumber + ' ' + self.$i18n.t('service.pressure'),
                id: fs.filtrationSystemId
              })
            }
          }
        })
      })
    },
    quickLink (link) {
      switch (link) {
        case 'customer':
          this.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'customer')
          this.$router.push('watersystem_list')
          break
        case 'device':
          this.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'device')
          this.$router.push('watersystem_list')
          break
        default:
          return
      }
    },
    getDomainConfig () {
      let domainConfig = utils.getDomainConfig()
      this.information = this.$t('home.information', [domainConfig.translations.home.information])
    },
    getFiltrationSystemCount () {
      http.request('get', '/service2/dashboard/api/Organizations/getFiltrationSystemCount')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get location data failed. (' + data.result + ')')
            return
          }
          this.filtrationSystemCount = data.count
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    getLocationCount () {
      http.request('get', '/service2/dashboard/api/Organizations/getLocationCount')
        .then(response => {
          const data = response.data

          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get location data failed. (' + data.result + ')')
            return
          }
          this.locationCount = data.count
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    }
  },
  mounted () {
    this.init()
  }
}
</script>


<style>

#home-notifications {
  border-right: 1px #CDD2E0 solid !important;
}
.alert.alert--outline {
  border-radius: 3px;
}
#home .expansion-panel {
  box-shadow: none;
}
#home .expansion-panel__container {
  background-color: rgba(0,0,0,0) !important;
}
#home .expansion-panel__header {
  height: 25px;
}
#home-main .expansion-panel__header {
  background-color: #E8EAF0
}
.expansion-panel__body .card{
  box-shadow: 0 1px 1px 1px rgba(0,0,0,.1);
}

/* カレンダー */
.fc-state-default {
  background-image:none;
  color: #999;
}

/* おしらせ行 */
.infomation-text {
  margin-left:10px;
}

</style>


// WEBPACK FOOTER //
// Home.vue?ffe14346